export default __webpack_public_path__ + "static/media/contact-bg.a7e2f196.png";